import { tns } from 'tiny-slider/src/tiny-slider';

const showsSlider = document.querySelector('.js-shows-slider');

if(showsSlider) {
  tns({
    container: showsSlider,
    mode: 'carousel',
    items: 1,
    loop: true,
    slideBy: '1',
    autoplay: true,
    touch: true,
    mouseDrag: true,
    prevButton: '.js-prev',
    nextButton: '.js-next',
    autoplayButtonOutput: false,
    navContainer: '.js-nav',
  })
}
